import { getHasInvestmentsEffect } from 'apps/investor/resources/investments/effects';
import { replace } from 'connected-react-router';
import { ConditionFn } from 'core/auth/components/with-conditional-page/conditional-page';
import { isLoggedInSelector } from 'core/auth/selectors';

export const RegisterAccessCondition: ConditionFn = async ({ resolveCondition, store, dispatch }) => {
  const isLoggedIn = isLoggedInSelector(store.getState());

  if (!isLoggedIn) {
    resolveCondition(true);
    return;
  }

  const hasInvestments = await getHasInvestmentsEffect(store.getState);

  // If the user has investments, condition should be false
  resolveCondition(!hasInvestments);

  if (hasInvestments) {
    // Redirect to the dashboard
    dispatch(replace('/dashboard'));
  }
};
